// eslint-disable-next-line import/prefer-default-export

module.exports = {
  isplainnumber(value) {
    return (/^[0-9]*$/).test(value);
  },
  containsonlylanguagechars(value) {
    return (/^[a-zA-ZÀ-ÿ\s.-]+$/).test(value);
  },
  loosephonevalidation(value) {
    if (value.length > 40) {
      return false;
    }
    return (/^[-0-9().+\s]+$/).test(value);
  },
};
